export default __webpack_public_path__ + "static/cafe_36016-6660dd9482f2ac7783e363cc2af8c364.png";